import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Prepends the environment-specific API base URL to relative backend requests.
 * Handles all URL prefixes used by the app: /api/, /auth/, /user/, /me, /logout
 */
@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  private readonly backendPrefixes = ['/api/', '/auth/', '/user', '/me', '/logout'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isBackendRequest(req.url)) {
      const apiReq = req.clone({
        url: `${environment.apiUrl}${req.url}`,
        withCredentials: true, // Required for cross-origin session cookies (SameSite=None)
      });
      return next.handle(apiReq);
    }
    return next.handle(req);
  }

  private isBackendRequest(url: string): boolean {
    return this.backendPrefixes.some(prefix => url.startsWith(prefix));
  }
}
